import { formatThousands } from '@restworld/utils-common';

// Slider bounds of the monthly earnings filter.
export const SALARY_RANGE_MIN = 500;
export const SALARY_RANGE_MAX = 5000;

/**
 * Text above the monthly earnings slider. With no filter set it shows `anyAmountLabel` instead of
 * "€0 - €0" (0 is not even a value the slider can hold); otherwise the range with the Italian
 * thousands separator.
 */
export const formatSalaryRangeText = (
  minSalary: number | null | undefined,
  maxSalary: number | null | undefined,
  anyAmountLabel: string
): string =>
  (minSalary === null || minSalary === undefined) && (maxSalary === null || maxSalary === undefined)
    ? anyAmountLabel
    : `€${formatThousands(minSalary ?? SALARY_RANGE_MIN)} - €${formatThousands(maxSalary ?? SALARY_RANGE_MAX)}`;
